import React, { Component } from "react";
import "styled-components/macro";

import guessMyDevice from "./utils/guess-my-device";

export default class BonusFeaturesTileCAM extends Component {
  initialState = {
    animationStep: -1,
  };
  animationMsInitial = 250;
  state = this.initialState;
  timers = [];
  feedHeight = 75;
  animationMs = this.animationMsInitial;
  device = guessMyDevice();
  render() {
    const { animationStep } = this.state;
    return (
      <div
        onMouseEnter={this.startAnimation}
        onMouseLeave={this.resetAnimation}
        css={`
          position: relative;
          display: inline-flex;
          margin: 16px 0 0;
          width: ${this.device !== "mobile" ? "66%" : "100%"};
          height: 500px;
          color: white;
          cursor: grab;
          border-radius: 15.0px;
          overflow: hidden;
          background-color: hsl(240 11% 95% / 1);
          box-shadow: 2.5px 2.2px 0px 0.5px hsl(240deg 8% 90%);
          border: 1px solid hsl(0deg 0% 54% / 40%);
          filter: brightness(1.07);
          transition: filter 140ms ease-out;
          &:hover {
            box-shadow: none;
            filter: brightness(1);
          }
        `}
      >
        <div
          css={`
            width: 50%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          `}
        >
          <div
            css={`
              padding: 39px 0 0 39px;
              font-weight: 600;
              font-size: 14px;
              color: hsl(240 50% 55% / 1);
            `}
          >
            CORETEXT ADAPTIVE MEMORY (C.A.M.)
          </div>
          <div
            css={`
              font-size: 24px;
              line-height: 122%;
              padding: 39px;
            `}
          >
            <div
              css={`
                font-size: 21px;
                font-weight: 600;
                color: hsl(240 10% 35% / 1);
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
              `}
            >
              Passively Organized Library
            </div>
            <div
              css={`
                line-height: 133.5%;
                font-size: 18px;
                color: hsl(240 10% 60% / 1);
              `}
            >
              RSS feeds are sorted by a non-algorithmic, simple
              point system. Whenever you use the command palette to navigate to
              an RSS feed outside of your browser's viewport, that RSS feed
              gains 1 point.
            </div>
          </div>
        </div>
        <div>
          {/* Browser perimeter */}
          <div
            css={`
              position: absolute;
              display: flex;
              right: -70px;
              width: 470px;
              height: 345px;
              border-bottom: 1px solid #acacac;
              border-left: 1px solid #acacac;
              border-bottom-left-radius: 8px;
            `}
          >
            {/* Sidebar */}
            <div
              css={`
                margin: -100px 0 0 21px;
                width: 290px;
                transform: translateY(
                  ${animationStep >= 5 ? this.feedHeight : 0}px
                );
                transition: transform ${this.animationMs}ms ease-out;
              `}
            >
              <div
                css={`
                  z-index: 0;
                  position: relative;
                  margin: 2px 0 0;
                  height: ${this.feedHeight}px;
                  background: #5858d3;
                  filter: saturate(0) brightness(1.5);
                  opacity: ${this.calcOpacity()};
                  transform: ${this.calcTransform(1)};
                  transition: ${this.calcTransition(1)};
                `}
              ></div>
              <div
                css={`
                  z-index: 0;
                  position: relative;
                  margin: 2px 0 0;
                  height: ${this.feedHeight}px;
                  background: #5858d3;
                  filter: saturate(0) brightness(1.5);
                  opacity: ${this.calcOpacity()};
                  transform: ${this.calcTransform(2)};
                  transition: ${this.calcTransition(2)};
                `}
              ></div>
              <div
                css={`
                  z-index: 0;
                  position: relative;
                  margin: 2px 0 0;
                  height: ${this.feedHeight}px;
                  background: #5858d3;
                  filter: saturate(0) brightness(1.5);
                  opacity: ${this.calcOpacity()};
                  transform: ${this.calcTransform(3)};
                  transition: ${this.calcTransition(3)};
                `}
              ></div>
              <div
                css={`
                  z-index: 0;
                  position: relative;
                  margin: 2px 0 0;
                  height: ${this.feedHeight}px;
                  background: #5858d3;
                  filter: saturate(0) brightness(1.5);
                  opacity: ${this.calcOpacity()};
                  transform: ${this.calcTransform(4)};
                  transition: ${this.calcTransition(4)};
                `}
              ></div>
              <div
                css={`
                  z-index: 0;
                  position: relative;
                  margin: 2px 0 0;
                  height: ${this.feedHeight}px;
                  background: #5858d3;
                  filter: saturate(0) brightness(1.5);
                  opacity: ${this.calcOpacity()};
                  transform: ${this.calcTransform(5)};
                  transition: ${this.calcTransition(5)};
                `}
              ></div>
              <div
                css={`
                  z-index: 0;
                  position: relative;
                  margin: 2px 0 0;
                  height: ${this.feedHeight}px;
                  background: #5858d3;
                  filter: saturate(0) brightness(1.5);
                  opacity: ${this.calcOpacity()};
                  transform: ${this.calcTransform(6)};
                  transition: ${this.calcTransition(6)};
                `}
              ></div>
              <div
                css={`
                  z-index: 1;
                  position: relative;
                  margin: 2px 0 0;
                  height: ${this.feedHeight}px;
                  background: #5858d3;
                  filter: ${this.calcSelectedFeedFilter()};
                  opacity: ${this.calcOpacity()};
                  transform: ${this.calcTransform(7)};
                  transition: ${this.calcTransition(7)};
                  animation-name: ${animationStep === 2 ? "flash" : "none"};
                  animation-duration: ${this.animationMs}ms;
                  animation-iteration-count: ${animationStep === 2 ? 1 : 0};
                  @keyframes flash {
                    0% {
                      filter: saturate(0) brightness(1.5);
                    }
                    100% {
                      filter: saturate(1) brightness(1);
                    }
                  }
                `}
              ></div>
            </div>
            {/* ReadingView */}
            <div
              css={`
                margin: 0 0 0 11px;
                width: 178px;
                height: calc(100% - 11px);
                background: hsl(0 0% 50% / 1);
                opacity: ${animationStep >= 1 || animationStep === -1 ? 1 : 0};
                transition: opacity ${this.animationMs}ms ease-out;
              `}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  startAnimation = () => {
    this.timers[0] = setTimeout(() => {
      this.setState({ animationStep: 0 });
      this.timers[1] = setTimeout(() => {
        // Enter feeds!
        this.setState({ animationStep: 1 });
        this.timers[2] = setTimeout(() => {
          // Blue flashhhh once
          this.setState({ animationStep: 2 });
          this.timers[3] = setTimeout(() => {
            // Make it stay blue
            this.setState({ animationStep: 3 });
            this.timers[4] = setTimeout(() => {
              // Transform selected feed up up up!
              this.setState({ animationStep: 4 });
            }, 1000);
            this.timers[5] = setTimeout(() => {
              // Move unselected feeds down down down down!
              this.setState({ animationStep: 5 });
            }, 1250);
          }, 500);
        }, 2000);
      }, 500);
    }, this.animationMs);
  };

  resetAnimation = () => {
    this.timers.forEach((timer) => {
      clearTimeout(timer);
    });
    this.animationMs = 0;
    this.setState(this.initialState, () => {
      this.animationMs = this.animationMsInitial;
    });
  };

  calcOpacity = () => {
    const { animationStep } = this.state;

    if (animationStep === 0)
    {
      return 0;
    } else
    {
      return 1;
    }
  };

  calcTransform = (order) => {
    const { animationStep } = this.state;

    if (animationStep === 0)
    {
      return "translateY(5px)";
    } else if (animationStep === 1)
    {
      return `translateY(0px)`;
    } else if (animationStep === 2)
    {
    } else if (animationStep === 3)
    {
    } else if (order === 7 && animationStep >= 4)
    {
      return "translateY(-530px)";
    } else if (order !== 7 && animationStep === 5)
    {
      return `translateY(0px)`;
    }
  };

  calcTransition = (order) => {
    const { animationStep } = this.state;
    const standardAnimation = `all ${this.animationMs}ms ease-out ${(order / 4) * this.animationMs
      }ms`;

    if (order === 7)
    {
      if (animationStep === 3)
      {
        return `all ${this.animationMs}ms ease-out`;
      }
      if (animationStep === 4)
      {
        return `all ${this.animationMs * 1.5}ms ease-out`;
      } else return standardAnimation;
    } else return standardAnimation;
  };

  calcSelectedFeedFilter = () => {
    const { animationStep } = this.state;

    if (animationStep === -1)
    {
      return "saturate(1) brightness(1)";
    } else if (animationStep < 3)
    {
      return "saturate(0) brightness(1.5)";
    } else if (animationStep >= 3)
    {
      return "saturate(1) brightness(1)";
    }
  };
}
